import { route, getCurrentUrl } from 'preact-router';
import { useEffect } from 'preact/hooks';

export const Redirect = ({ to }) => {
    useEffect(() => {
        if (getCurrentUrl() !== to)
            route(to, true);
    });
    return null;
};